const ActiveSearchedIcon = () => {
  return <img src="/images/active-searched.svg" alt="active-searched-icon" />;
};

export default ActiveSearchedIcon;
